$.TemplateMaster = {
    SearchProduct: (language) => {
        let list = $("#productSearchModal .list-group");
        list.empty();
        $("#productSearchModal #noRecordsFound")
            .removeClass("d-block")
            .addClass("d-none");

        let search = $("#productSearchModal input").val();
        let res = $.Backend.SearchProduct(search, language, false);
        res.then(function (response) {
            const data = response.data;
            if (data.products.length > 0) {
                for (let product of data.products)
                    list.append(
                        `<a href="${
                            product.page ?? "#"
                        }" class="list-group-item list-group-item-action">${
                            product.name
                        } (${product.partNumber})</a>`
                    );
            } else {
                $("#productSearchModal #noRecordsFound")
                    .removeClass("d-none")
                    .addClass("d-block");
            }
        });
    },
    SetCookie: (name, value, ttl) => {
        console.log(name, value);
        let expires = "";
        if (ttl) {
            let date = new Date();
            date.setTime(date.getTime() + ttl * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value ?? ""}${expires}; path=/`;
    },
    Consent: (name, essential, functional, performance, targeting) => {
        if (name.trim() === "") return;
        $.TemplateMaster.SetCookie(
            name,
            JSON.stringify({ essential, functional, performance, targeting }),
            60 * 60 * 24 * 50
        );
    },
};

$(document).ready(function () {
    $("#openProductSearchBtn").click(function () {
        $("#productSearchModal input").val("");
        $("#productSearchModal .list-group").empty();
        $("#productSearchModal #noRecordsFound")
            .removeClass("d-block")
            .addClass("d-none");
        setTimeout(function () {
            $("#productSearchModal input").focus();
        }, 500);
    });

    $("#productSearchModal input").on("keypress", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            $("#productSearchModal #productSearchBtn").click();
        }
    });

    $(".video").each(function () {
        let video = $(this).find("video")[0];

        $(this)
            .find(".play-btn")
            .on("click", function () {
                video.play();
            });

        $(this)
            .find(".btn-close")
            .on("click", function () {
                video.pause();
            });
    });

    if ($("#consentModal") && $("#consentDetailsModal")) {
        const m = new bootstrap.Modal($("#consentModal"));
        const dm = new bootstrap.Modal($("#consentDetailsModal"));

        $("#consentAcceptAll").on("click", () => {
            $.TemplateMaster.Consent(
                window.requestedConsent,
                true,
                true,
                true,
                true
            );
            window.location.reload();
        });
        $("#consentRejectAll").on("click", () => {
            $.TemplateMaster.Consent(
                window.requestedConsent,
                false,
                false,
                false,
                false
            );
            window.location.reload();
        });
        $("#consentDetails").on("click", () => {
            m.hide();
            dm.show();
        });

        $("#consentSaveSettings").on("click", () => {
            const functional = $("#functionalConsent").is(":checked");
            const performance = $("#performanceConsent").is(":checked");
            const targeting = $("#targetingConsent").is(":checked");

            $.TemplateMaster.Consent(
                window.requestedConsent,
                true,
                functional,
                performance,
                targeting
            );
            window.location.reload();
        });

        if (window.requestConsent === true) m.show();
    }
});
